import { useQuery } from "@tanstack/react-query";
import {
  EuTaxonomyCompanyActivityDetailDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_EU_TAXONOMY_ACTIVITY } from "../domain";

import { euTaxonomyCompanyActivityApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_COMPANY_ACTIVITY_DETAIL = "GET_COMPANY_ACTIVITY_DETAIL";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const getCompanyActivityDetail = async (
  companyActivityId: string,
): Promise<EuTaxonomyCompanyActivityDetailDto> => {
  const response =
    await euTaxonomyCompanyActivityApi.euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivityDetail(
      companyActivityId,
    );

  return response.data;
};

export const useGetCompanyActivityDetail = (
  user: UserProfileDto | null,
  companyActivityId: string,
): {
  companyActivityDetail?: EuTaxonomyCompanyActivityDetailDto;
  companyActivityDetailEnabled: boolean;
  isSuccessGetActivityDetail: boolean;
  isLoadingGetActivityDetail: boolean;
  refetchDetail: () => void;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { data, isSuccess, isLoading, refetch } = useQuery({
    queryKey: [DOMAIN_EU_TAXONOMY_ACTIVITY, ACTION_GET_COMPANY_ACTIVITY_DETAIL],
    queryFn: () => getCompanyActivityDetail(companyActivityId),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    companyActivityDetail: data,
    companyActivityDetailEnabled: enabled,
    isSuccessGetActivityDetail: isSuccess,
    isLoadingGetActivityDetail: isLoading,
    refetchDetail: refetch,
  };
};
